'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _MapControlButtons = require('./MapControlButtons.scss');var _MapControlButtons2 = _interopRequireDefault(_MapControlButtons);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var MapControlButtons = function MapControlButtons() {return (
    _react2.default.createElement('div', { className: _MapControlButtons2.default.ctrlButtons },
      _react2.default.createElement('button', { className: _MapControlButtons2.default.ctrlZoomIn, type: 'button' },
        _react2.default.createElement('span', { className: _MapControlButtons2.default.icon })),

      _react2.default.createElement('button', { className: _MapControlButtons2.default.ctrlZoomOut, type: 'button' },
        _react2.default.createElement('span', { className: _MapControlButtons2.default.icon }))));};exports.default =




MapControlButtons;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MapControlButtons/MapControlButtons.js
// module id = 2708
// module chunks = 0